import React from "react";
import PropTypes from "prop-types";

import Button from "../Button/Button.jsx";
import SvgIcon from "../Icon/SvgIcon.jsx";

import getClassNames from "../../utils/helpers/getClassNames";
import "./styles/style.scss";

const ALERT_TYPES = {
  SUCCESS: {
    type: "success",
    icon: <SvgIcon name="alertSuccess" />,
  },
  WARN: {
    type: "warn",
    icon: <SvgIcon name="alertWarn" />,
  },
  ERROR: {
    type: "error",
    icon: <SvgIcon name="alertError" />,
  },
};

const Alert = ({ type, actionAlert, titleButton, ...rest }) => {
  const classNames = getClassNames(["alert", `alert--${type}`]);

  return (
    <div className={classNames}>
      <div className="alert__icon">{ALERT_TYPES[type.toUpperCase()].icon}</div>
      <div className="alert__message">
        <div className="alert__message-content">{rest.children}</div>
        {actionAlert && (
          <Button size="md" color={type} onClick={actionAlert}>
            {titleButton}
          </Button>
        )}
      </div>
    </div>
  );
};

Alert.propTypes = {
  type: PropTypes.string,
  actionAlert: PropTypes.func,
  titleButton: PropTypes.string,
};

Alert.defaultProps = {
  type: "error",
  actionAlert: null,
  titleButton: "",
};

export default Alert;
